import type { NutzTariff } from '@/features/Sparten/nutz/types';
import type { CampTariff } from '@/features/Sparten/camp/types';

export enum WKZ {
  KRAFTRAEDER_KRAFTROLLER = '003',
  LEICHTKRAFTROLLER_50_125_CCM = '014',
  LEICHTKRAFTRAEDER_50_125_CCM = '024',
  TRIKES = '030',
  QUADS = '031',
  PKW = '112',
  CAMPING_WOHNMOBIL = '127',
  LIEFERWAGEN_WERKVERKEHR = '251',
  LIEFERWAGEN_GEWERBLICHER_VERKEHR = '261',
  LKW_WERKVERKEHR = '351',
  LKW_GEWERBLICHER_VERKEHR = '361',
  ZUGMASCHINE_WERKVERKEHR = '401',
  ZUGMASCHINE_GEWERBLICHER_VERKEHR = '411',
  ZUGMASCHINE_LANDWIRTSCHAFTLICH = '451',
  WOHNWAGEN_ANHAENGER = '541',
  ANHAENGER_PRIVAT_UND_WERKVERKEHR = '581',
  ANHAENGER_GEWERBLICHER_VERKEHR = '591',
}

export interface KfzCompanyWkzMeta {
  wkzs?: string[];
}

export type KfzFeatureItem = Record<string, string[]> | null;

export interface ErstfahrzeugSchema {
  fahrleistung: number;
  gesellschaftID: number;
  isVonPartner: boolean;
  juengsterFahrerGeburtsdatum: Date | null;
  nutzerkreis: string;
  nutzungsart: string;
  sfKlasseKH: string;
  sfKlasseVK: string;
  wkz: string;
}

export interface ErstfahrzeugContractSchema {
  kennzeichen: string;
  versicherungsscheinnummer: string;
}

export type KfzNotPkwTariff = NutzTariff | CampTariff;
